export enum AdminTabEnum {
  Collaborators = 'tabCollaborators',
  Profiles = 'tabProfiles',
}

export const isValidAdminTab = (value: unknown): value is AdminTabEnum => {
  return Object.values(AdminTabEnum).includes(value as AdminTabEnum);
};

export const getAdminTab = (value: unknown): AdminTabEnum | undefined => {
  if (isValidAdminTab(value)) {
    return value;
  }

  return undefined;
};
